<!--
~ Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
-->

@if (!multiselect) {
  <ngf-single-select [clearDropdownEvent]="clearDropdownEvent" [showOverflowTooltip]="showOverflowTooltip" [ariaLabelledby]="ariaLabelledby" [ariaDescribedby]="ariaDescribedby" />
}
@if (multiselect) {
  <ngf-multi-select [ariaLabelledby]="ariaLabelledby" [ariaDescribedby]="ariaDescribedby" />
}

<ngf-options-overlay [triggerRef]="elementRef" [disabled]="disabled" [readonly]="isReadonly">
  <ng-content select="ngf-options-container" />
</ngf-options-overlay>

@if (enableOptionsAnnouncement) {
  <div
    class="ngf-sr-only"
    aria-live="polite"
    aria-atomic="true">
    {{ optionsAnnouncement() }}
  </div>
}
